import type { Goal } from "instantdb/types";

export const ENERGY_GOALS: Partial<Goal>[] = [
  {
    id: "manage-afternoon-slump",
    title: "Manage afternoon slump",
    description: "Develop strategies to maintain energy in the afternoon",
    symbol: "⚡",
  },
  {
    id: "optimize-morning-routine",
    title: "Optimize morning routine",
    description: "Create a morning routine that boosts energy for the day",
    symbol: "🌅",
  },
  {
    id: "regular-energy-breaks",
    title: "Regular energy breaks",
    description: "Take short breaks throughout the day to recharge",
    symbol: "⏱️",
  },
];
